
import React, { useEffect } from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import backgroundImage from './img/background_image.jpg'
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Login';
    document.body.style.backgroundColor = 'rgb(14, 13, 14)';

  });

  const api = new ServiceApi(this);
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <div className="container" style={{
      background: `url(${backgroundImage}) no-repeat 100%`,
      minHeight: '100vh',
      backgroundSize: 'cover',
      backgroundBlendMode: 'darken',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex'
    }}>
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
    </div>
  );
}

export default Login;
